<template>
  <div class="field-list-component">
    <CardComponent class="d-flex flex-column content-card">
      <template v-slot:title>
        <v-row class="ma-0">
          <v-col class="pa-0">
            <span>{{title}}</span>
          </v-col>
          <v-spacer/>
          <v-col class="text-right py-0">
            <EditButton v-model="edit" @save="onSave" @discard="onDiscard" @edit="onEdit"/>
          </v-col>
        </v-row>
      </template>
      <EditorCardComponent v-if="edit" v-model="localFields"/>
      <FieldViewCard v-if="!edit" :fields="localFields"/>
    </CardComponent>
  </div>
</template>

<script>
import EditorCardComponent from "@/components/form/EditorCardComponent";
import {ref, watch, toRefs} from "@vue/composition-api";
import EditButton from "@/components/buttons/EditButton";
import CardComponent from './CardComponent'
import FieldViewCard from "@/components/form/FieldViewCard";

export default {
  name: "FieldListComponent",
  components: {FieldViewCard, EditButton, CardComponent, EditorCardComponent},
  props: {
    value: Array,
    title: String
  },
  setup(props, {emit}) {

    const edit = ref(false)
    const localFields = ref(props.value.map(field => Object.assign({}, field)))

    const fieldRefs = props.value.reduce((acc, cur) => {
      return [...acc, ...Object.values(toRefs(cur))]
    }, [])
    watch(
      [...fieldRefs, () => props.value],
      () => {
        localFields.value = props.value.map(field => Object.assign({}, field))
      }
    )

    function onSave() {
      localFields.value.forEach((field) => {
        field.edit = false
      })
      localFields.value = localFields.value.filter((field) => typeof field.type !== 'undefined' && field.type !== '')
      emit('input', localFields.value)
    }

    function onDiscard() {
      localFields.value = props.value.map(field => Object.assign({}, field))
    }

    function onEdit() {
      localFields.value.forEach((field) => {
        field.edit = false
      })
    }

    return {edit, localFields, onSave, onDiscard, onEdit}
  }
}
</script>

<style scoped lang="scss">
.field-list-component {
  height: 100%;
}

.content-card {
  max-height: 100%;
}


</style>
